/** What a drag exposes before the drop: item kinds and MIME types, no names. */
export interface DraggedItem {
  kind: string;
  type: string;
}

/** A drag carrying files from outside the page. */
export const isFileDrag = (
  types: ArrayLike<string> | Iterable<string>
): boolean => Array.from(types).includes('Files');

/**
 * Every dragged item is a file of an allowed type. An empty type is let
 * through: some systems do not report one, and the extension check on
 * drop decides.
 */
export const dragHasOnlyAllowedFiles = (
  items: ArrayLike<DraggedItem> | Iterable<DraggedItem>,
  allowedTypes: readonly string[]
): boolean =>
  Array.from(items).every(
    (item) =>
      item.kind === 'file' &&
      (item.type === '' || allowedTypes.includes(item.type))
  );
